import { JWT_KEY } from "Utils/AuthUtils";
import { LocalStorageKeys } from "Utils/Storage/LocalStorage/LocalStorageKeys";
import {
  setLocalStorageItem,
  removeLocalStorageItem,
} from "Utils/Storage/LocalStorage/SecureLocalStorage";

export function setToken(result: { token?: string | null | undefined }) {
  if (result.token) {
    setLocalStorageItem(JWT_KEY, `Bearer ${result.token}`);
    return;
  }

  removeLocalStorageItem(JWT_KEY);
}

export const getQuickPaymentAttemptedKey = (
  transactionPublicID: string,
): `${LocalStorageKeys.QuickPaymentAttempted}_${string}` =>
  `${LocalStorageKeys.QuickPaymentAttempted}_${transactionPublicID}`;

/**
 * The currency the dashboard balance shows (mobile hero and desktop card), per persona — a
 * person's Customer and Merchant personas hold different accounts, so each remembers its own choice.
 */
export const getDashboardBalanceCurrencyKey = (
  personaPublicID: string,
): `${LocalStorageKeys.DashboardBalanceCurrency}_${string}` =>
  `${LocalStorageKeys.DashboardBalanceCurrency}_${personaPublicID}`;
